import { render, staticRenderFns } from "./ProcessLog.vue?vue&type=template&id=1b608b05&"
import script from "./ProcessLog.vue?vue&type=script&lang=js&"
export * from "./ProcessLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports